import { render, staticRenderFns } from "./ReferralCustomerModal.vue?vue&type=template&id=a0e459fc"
import script from "./ReferralCustomerModal.vue?vue&type=script&lang=js"
export * from "./ReferralCustomerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports